import React from 'react';
import { Row, Container } from 'react-bootstrap';
import { ImUserMinus } from "react-icons/im";
import * as apiUtility from '../../config/APIUtils';
import { Button, Stack, Typography } from '@mui/joy';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import { DialogActions, DialogContent } from '@mui/joy';



function DeactivateAccount(props) {

    const handleDeactivation = async e => {
        e.preventDefault();
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = "login/deactivate";
        apiRequest.data = { "login_id": props.data };
        await apiUtility.sendAsyncAPIDataPOST(apiRequest).then(res => {
            props.handleUpdateCallback(res.data.msg);
        }).catch(err => {
            console.log("Error at deactivation: ", err);
        });
    }

    return (

        <Modal open={props.show} onClose={props.onHide} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} disableScrollLock={true}>
            <ModalDialog sx={{ opacity: props.show ? 1 : 0, transition: `opacity 300ms` }}>
                <DialogContent>
                    <Container style={{ "width": "90%" }}>
                        <Row className='text-center'>
                            <p className='text-center'><ImUserMinus style={{ "fontSize": "5pc", "color": "#006699" }} /></p>
                            <Typography level="title-lg" sx={{ "color": "#006699" }}>Once account deactivated, Please contact administrator to enable it again.</Typography>
                        </Row>
                    </Container>
                </DialogContent>
                <DialogActions>
                    <Stack direction="row" justifyContent="center" alignItems="center" sx={{ width: "100%" }} spacing={2}>
                        <Button color='danger' variant='soft' onClick={handleDeactivation}> Deactivate Profile </Button>
                        <Button color='warning' variant='soft' onClick={props.onHide}> Never Mind </Button>
                    </Stack>
                </DialogActions>
            </ModalDialog>
        </Modal>

    );
}
export default DeactivateAccount;